<template>
  <div class="wrapper">
    <!-- Modal Component -->
    <b-modal
      id="myModal"
      v-model="formModal.status"
      @cancel="resetDetailForm"
      @ok="submit"
      @show="$v.$reset()"
      @shown="
        getCompanyFacilities(company);
        getPalletTypes();
      "
      size="lg"
      ref="modalContenido"
    >
      <template slot="title"> </template>
      <b-row>
        <b-col lg="6">
          <b-jumbotron>
            <template slot="header">
              <p>{{ calculateGross }}</p>
            </template>

            <template slot="lead">
              <p>{{ calculateGross }} Kg Brutos</p>
              <p class="font-weight-bold font-2xl">
                {{ calculateNet }} Kg Netos
              </p>
            </template>
            <p v-if="!connected" class="text-danger">
              * Conexión con báscula no establecida
            </p>
          </b-jumbotron>
        </b-col>

        <b-col lg="6">
          <b-form-group
            id="example-input-group-1"
            aria-describedby="input-1-live-feedback"
            label="Número de Pallet (Opcional)"
            description="Ingrese numero de pallet. Deje en blanco si desea un numero automático."
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                placeholder="123456789"
                :state="
                  $v.contentData.pallet_number.$dirty
                    ? !$v.contentData.pallet_number.$error
                    : null
                "
                v-model="$v.contentData.pallet_number.$model"
              >
              </b-form-input>

              <b-input-group-append>
                <b-input-group-text>#</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group
            v-if="contentData.interplanta === true"
            label="Planta de proceso (CSP)"
            label-for="plantSelect"
          >
            <b-form-select
              id="plantSelect"
              v-model="$v.contentData.plant.$model"
              :options="companyFacilities.plants"
              :state="
                $v.contentData.plant.$dirty
                  ? !$v.contentData.plant.$error
                  : null
              "
              :disabled="disabledFields.plant"
              value="Seleccione..."
            />
          </b-form-group>
          <b-form-group
            v-if="existing_pallet === true"
            label="Pallet"
            label-for="palletSelect"
          >
            <b-form-select
              id="palletSelect"
              v-model="contentData.pallet"
              :options="pallets"
              value="Seleccione..."
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Tipo/peso pallet" label-for="containerSelect">
            <b-form-select
              id="containerSelect"
              :state="
                $v.contentData.pallet_type.$dirty
                  ? !$v.contentData.pallet_type.$error
                  : null
              "
              v-model="$v.contentData.pallet_type.$model"
              :options="pallet_types"
              value="Seleccione..."
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Formato/Recipiente" label-for="containerSelect">
            <v-select
              :options="productSet.containers"
              v-model="$v.contentData.container.$model"
              :state="
                $v.contentData.container.$dirty
                  ? !$v.contentData.container.$error
                  : null
              "
              label="text"
              :reduce="(text) => text.value"
              class="style-chooser"
            >
            </v-select>
          </b-form-group>
          <b-form-group
            v-if="contentData.interplanta === true"
            label="Destino (Opcional)"
          >
            <b-form-select
              id="destination"
              text-field="name"
              value-field="id"
              v-model="contentData.destination"
              :options="destinations"
            >
            </b-form-select>
          </b-form-group>

          <div v-if="contentData.interplanta === true">
            <b-form-group
              v-for="(type, index) in productSet.spec_type"
              v-bind:label="type.name"
              :key="index"
              label-for="basicSelect"
            >
              <b-form-select
                id="specSelect"
                v-model="contentData.specifications[index]"
              >
                <option
                  v-for="spec in type.specs"
                  :key="spec.value"
                  v-bind:value="spec.value"
                >
                  {{ spec.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>

          <div
            v-if="
              productSet.spec_type_bulk.length > 0 &&
              contentData.interplanta === false
            "
          >
            <b-form-group
              v-for="(type, index) in productSet.spec_type_bulk"
              v-bind:label="type.name + ' (Opcional)'"
              :key="index"
              label-for="basicSelect"
            >
              <b-form-select
                id="specSelect"
                v-model="contentData.specifications[index]"
              >
                <option
                  v-for="spec in type.specs"
                  :key="spec.value"
                  v-bind:value="spec.value"
                >
                  {{ spec.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>

          <b-form-group label="Clasificación" description="">
            <b-input-group>
              <b-form-input
                type="text"
                placeholder=""
                v-model="contentData.classification"
                style="text-transform: uppercase"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group label="Peletizado">
            <b-form-checkbox-group
              v-model="contentData.palletizing"
              :options="optionsPalletizing"
            ></b-form-checkbox-group>
          </b-form-group>

          <b-form-group
            id="example-input-group-1"
            aria-describedby="input-1-live-feedback"
            label="Cantidad de Bandejas"
            description="Por favor, cuente la Formato/Recipiente antes de registrar."
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                placeholder="Ingrese unidades resultantes"
                :state="
                  $v.contentData.quantity.$dirty
                    ? !$v.contentData.quantity.$error
                    : null
                "
                v-model="$v.contentData.quantity.$model"
              >
              </b-form-input>

              <b-input-group-append>
                <b-input-group-text>Un</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group
            v-if="(contentData.interplanta === false) & !connected"
            description="Los kilos que indica la pesa/romana."
            label="Kilos brutos"
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                :state="
                  $v.contentData.gross_kilograms.$dirty
                    ? !$v.contentData.gross_kilograms.$error
                    : null
                "
                v-model="$v.contentData.gross_kilograms.$model"
                :disabled="contentData.interplanta === true"
                placeholder="Ingrese kilos"
              >
              </b-form-input>
              <b-input-group-append>
                <b-input-group-text>Kg</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  decimal,
  integer,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { bus } from "../../main";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import Vue from "vue";
import { mapState, mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

export default {
  name: "ModalContenido",
  components: { vSelect },
  // This props are receiving the data from the parent component
  props: [
    "company",
    "client_customer",
    "waybillID",
    "formModal",
    "waybillDATE",
    "number_waybill",
    "sypplyItems"
  ],
  data() {
    return {
      loading: false,
      modalTitle: "Agregar detalles",
      editing_modal: false,
      contentData: {
        id: null,
        pallet_number: "",
        destination: null,
        pallet_type: null,
        lot: "",
        interplanta: false,
        product: "",
        variety: "",
        condition: "",
        origin: "",
        product_type: {
          exportable: null
        },
        plant: "",
        pallet: "",
        process_date: "",
        container: "",
        specifications: [],
        quantity: null,
        gross_kilograms: "0.00",
        net_kilograms: null,
        origin_kilograms: "",
        other: [],
        classification: "",
        palletizing: []
      },
      productSet: {
        product_types: [],
        containers: [],
        varieties: [],
        spec_type: [],
        spec_type_bulk: []
      },
      pallet_types: [
        { value: 17, text: "Taco" },
        { value: 18, text: "Yugo" }
      ],
      companyFacilities: [],
      existing_pallet: false,
      pallets: [],
      destinations: [],
      products: [],
      conditions: [
        { value: "Orgánico", text: "Orgánico" },
        { value: "Convencional", text: "Convencional" },
        { value: "Org. System Approach", text: "Org. System Approach" }
      ],
      disabledFields: {
        product: false,
        variety: false,
        condition: false,
        origin: false,
        plant: false
      },
      optionsPalletizing: [
        { text: "A Piso", value: "A Piso" },
        { text: "Gasificado", value: "Gasificado" }
      ]
    };
  },
  validations: {
    contentData: {
      product: { required },
      variety: { required },
      origin: { required },
      plant: {
        required: requiredIf(function () {
          return this.interplanta;
        })
      },
      condition: { required },
      product_type: { required },
      pallet_type: { required },
      container: { required },
      pallet_number: {},
      origin_kilograms: { decimal },
      quantity: {
        required,
        integer,
        minValue: minValue(1)
      },
      // net_kilograms: {
      //   required,
      //   decimal,
      //   minValue : minValue(0)
      // },
      gross_kilograms: {
        required: requiredIf(function () {
          return this.connected;
        }),
        decimal
        // minValue : minValue(0.01)
      }
    }
  },
  computed: {
    ...mapGetters("socketModule", ["selectedScale"]),
    ...mapState("socketModule", ["socketWeight", "connected"]),
    kilogramDif() {
      var num =
        ((this.contentData.net_kilograms - this.contentData.origin_kilograms) /
          this.contentData.origin_kilograms) *
        100;
      return num.toFixed(2);
    },
    autoNumber() {
      return (
        this.contentData.pallet_number === "" ||
        this.contentData.pallet_number === null
      );
    },
    calculateExport() {
      const num =
        parseFloat(this.contentData.container.net_weight) *
          this.contentData.quantity || 0;
      return this.contentData.interplanta
        ? num
        : this.contentData.net_kilograms;
    },
    calculateGross() {
      if (this.connected && !this.contentData.id) {
        return this.socketWeight;
      } else {
        return this.contentData.gross_kilograms;
      }
    },
    calculateNet() {
      if (this.contentData.interplanta) {
        const num = parseFloat(this.calculateExport);
        this.contentData.gross_kilograms =
          parseFloat(this.contentData.container.gross_weight) *
            this.contentData.quantity || 0;
        return isNaN(num) ? "En espera..." : parseFloat(num).toFixed(2);
      } else {
        const tara =
          parseFloat(this.contentData.container.material_weight) *
            this.contentData.quantity || 0;
        var num = 0;
        if (this.connected && !this.contentData.id) {
          num = (
            this.socketWeight -
            this.contentData.pallet_type -
            tara
          ).toFixed(2);
        } else {
          num = (
            this.contentData.gross_kilograms -
            this.contentData.pallet_type -
            tara
          ).toFixed(2);
        }

        return isNaN(num) ? "En espera..." : parseFloat(num).toFixed(2);
      }

      // return this.contentData.net_kilograms
    },
    modalSize() {
      return this.interplanta ? "lg" : "md";
    }
  },
  watch: {
    existing_pallet: {
      handler(val) {
        this.getWaybillPallets(this.waybillID);
      }
    },
    "contentData.product_type": {
      handler(val) {
        this.getProductContainers(val.exportable, this.contentData.product);
      }
    }
  },
  created() {
    bus.$off("editContent");
    bus.$on("editContent", (data) => {
      this.contentData.container = "";
      this.contentData.container = data.container;

      this.editing_modal = true;
      this.existing_pallet = true;
      this.getWaybillPallets(this.waybillID);
      this.contentData.product = data.product;
      this.contentData.id = data.id;
      this.contentData.lot = data.lot;

      // First select product to run the apis and fill the select inputs. Then continue filling the modal inputs.
      this.getProductSet(data.product);
      this.contentData.variety = data.variety;
      this.contentData.condition = data.condition;
      this.contentData.pallet = data.pallet;
      this.contentData.origin = data.origin;
      this.contentData.interplanta = /true/i.test(data.exportable);

      const specs = [];
      for (let key in data.specifications) {
        const spec = data.specifications[key].id;
        specs.push(spec);
      }
      this.contentData.specifications = specs;

      this.contentData.quantity = data.quantity;
      this.contentData.net_kilograms = data.net_kilograms;
      this.contentData.origin_kilograms = data.origin_kilograms;
      this.contentData.gross_kilograms = data.gross_kilograms;
      this.contentData.product_type = {
        id: data.product_type,
        text: data.product_type_name,
        exportable: /true/i.test(data.exportable)
      };
      // this.getProductContainers(data.container.bulk, data.product);

      // this.contentData.container ={'id': data.container.id, 'net_weight': data.container.net_weight};

      this.contentData.classification = data.classification;
      this.formModal.status = true;

      this.contentData.palletizing = data.palletizing.split(",");
    });

    bus.$off("createContent");
    bus.$on("createContent", (data) => {
      this.resetDetailForm();
      this.getWaybillPallets(this.waybillID);
      this.contentData.product = data.product;
      this.contentData.lot = data.id;
      this.contentData.interplanta = /true/i.test(data.exportable);
      // First select product to run the apis and fill the select inputs. Then continue filling the modal inputs.
      this.getProductSet(data.product);
      this.contentData.variety = data.variety;
      this.contentData.condition = data.condition;
      this.contentData.origin = data.origin;
      this.contentData.gross_kilograms = "0.00";
      this.contentData.product_type = {
        id: data.product_type,
        text: data.product_type_name,
        exportable: /true/i.test(data.exportable)
      };
      this.formModal.status = true;
    });
  },
  methods: {
    ...mapActions("socketModule", [
      "socketEmitSendMessage",
      "namespaceSocketEmitSendMessage",
      "socketDisconnect",
      "socketConnect",
      "namespaceSocketConnect",
      "namespaceSocketDisconnect"
    ]),

    resetDetailForm() {
      this.contentData.id = null;
      this.contentData.origin = null;
      this.contentData.interplanta = false;
      this.contentData.product = null;
      this.contentData.variety = null;
      this.contentData.condition = null;
      this.contentData.product_type = [
        {
          exportable: null
        }
      ];
      this.contentData.plant = null;
      this.contentData.pallet = null;
      this.contentData.process_date = null;
      this.contentData.container = "";
      this.contentData.specifications = [];
      this.contentData.quantity = null;
      this.contentData.gross_kilograms = 0.0;
      this.contentData.pallet_number = "";
      this.contentData.destination = null;
      this.contentData.net_kilograms = null;
      this.contentData.origin_kilograms = null;
      this.contentData.other = [];
      this.productSet = {
        product_types: [],
        containers: [],
        varieties: [],
        spec_type: [],
        spec_type_bulk: []
      };
      this.existing_pallet = false;
      this.contentData.classification = "";
      this.contentData.palletizing = [];
    },

    // ******** Getting variables based on selections

    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.products = products;
        })
        .catch((error) => console.log(errors));
    },

    getPalletTypes() {
      this.$axios
        .get("/api/v1/pallettype/")
        .then((res) => {
          // console.log(res)
          const data = res.data;
          const pallet_types = [];
          for (let key in data) {
            const pallet_type = data[key];
            pallet_types.push(pallet_type);
          }
          this.pallet_types = pallet_types;
        })
        .catch((error) => console.log(errors));
    },

    getBulkSpecs(a) {
      this.$axios
        .get("/production/get_bulk_specs/" + a)
        .then((res) => {
          const data = res.data.spec_type;
          const specs = [];
          for (let key in data) {
            const spec = data[key];
            specs.push(spec);
          }
          this.productSet.spec_type_bulk = specs;
          // this.productSet.spec_type_bulk = res.data.spec_type;
        })
        .catch((error) => console.log(error));
    },

    getCompanyFacilities(a) {
      this.$axios
        .get("/production/get_company_facilities/" + a)
        .then((res) => {
          this.companyFacilities = res.data;
          this.contentData.plant = this.companyFacilities.plants[0].value;
          this.contentData.origin = this.companyFacilities.origins[0].value;
          this.disabledFields.plants = false;
          this.disabledFields.origins = false;
        })
        .catch((error) => {
          this.disabledFields.plants = true;
        });
    },
    getProductContainers(exportable, product) {
      if (product == null) {
      } else {
        const url = exportable ? "std_company" : "bulk_company";
        this.$axios
          .get("/api/v1/container/" + product + "/" + url + "/", {
            params: {
              company: this.client_customer
            }
          })
          .then((res) => {
            this.productSet.containers = res.data;
          })
          .catch((error) => console.log(error.menssaje));
      }
    },

    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.productSet.spec_type = res.data.spec_type;
          this.productSet.varieties = res.data.varieties;

          const items = [];
          for (let key in res.data.product_types) {
            if (res.data.product_types[key].waste == false) {
              items.push(res.data.product_types[key]);
            }
          }

          this.productSet.product_types = items;
        })
        .catch((error) => console.log(error));
    },
    changeTipoProducto(obj) {
      if (obj.exportable == true) {
        this.contentData.interplanta = true;
      } else {
        this.contentData.specifications = [];
        this.contentData.interplanta = false;
      }
    },

    // ********  End getting variables based on selections

    getWaybillPallets(a) {
      this.$axios
        .get("/production/get_waybill_pallets/" + a)
        .then((res) => {
          const data = res.data.data;
          const items = [];
          for (let key in data) {
            const item = data[key];
            items.push(item);
          }
          this.pallets = items;
        })
        .catch((error) => console.log(errors));
    },
    submit: function (evt) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        evt.preventDefault();
        this.$emit("validate", false);
      } else {
        this.$emit("validate", true);
        if (this.contentData.id === null) {
          this.createContent();
        } else {
          this.updateContent(this.contentData.id);
        }
        this.resetDetailForm();
        this.$nextTick(() => {
          this.$refs.modalContenido.hide();
        });
      }
    },
    createSupply(obj) {
      this.$axios({
        method: "POST",
        url: "/api/supplies/waybill-supply/reception_supply/",
        data: {
          receipt_waybill: this.waybillID,
          container_id: obj.container,
          quantity: obj.quantity,
          client_customer: this.client_customer,
          waybill_date: this.waybillDATE,
          number_waybill: this.number_waybill
        }
      })
        .then((res) => {
          if (res.data.result == 1) {
            let new_sypply_item = {
              supply_code: res.data.supply.supply.code,
              supply_name: res.data.supply.supply.name,
              supply_lot: res.data.supply.supply_lot,
              quantity: res.data.supply.quantity
            };

            this.$emit("loadSupplyDetails");
            miniToastr.success("Materiales creados con éxito", "");
          }

          if (res.data.result == 2) {
            miniToastr.error(
              "Imposible crear el Material formato no tiene ingresada la receta",
              ""
            );
          }
        })
        .catch((error) => {
          console.log("%o", error);
        });
    },
    createContent() {
      const objData = {
        container: this.contentData.container.id,
        quantity: Number(this.contentData.quantity)
      };

      if (this.existing_pallet == false) {
        const palletData = {
          number: this.contentData.pallet_number,
          destination: this.contentData.destination,
          auto_number: this.autoNumber,
          receipt_waybill: this.waybillID,
          client: this.$store.getters.user.ID_CLIENTE,
          tipo: 1,
          contents: [
            {
              quantity: Number(this.contentData.quantity),
              net_kilograms: Number(this.calculateNet),
              origin_kilograms: Number(this.contentData.origin_kilograms),
              gross_kilograms: Number(this.calculateGross),
              origin: this.contentData.origin,
              condition: this.contentData.condition,
              lot: this.contentData.lot,
              product_type: this.contentData.product_type.id,
              pallet: "",
              process_id: "",
              overweight_type: "0",
              creation_date: this.waybillDATE,
              variety: this.contentData.variety,
              client_customer: this.client_customer,
              waybill: this.waybillID,
              container: this.contentData.container.id,
              plant: this.contentData.plant,
              specifications: this.contentData.specifications.filter(Boolean),
              classification: this.contentData.classification,
              palletizing: this.contentData.palletizing.join()
            }
          ]
        };

        this.loading = true;
        this.$axios
          .post("/api/v1/content/create_process_content/", palletData)
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              this.formModal.status = false;
              this.resetDetailForm();

              this.$emit("refreshContents", this.waybillID);
              miniToastr.success("Operación realizada con éxito", "");
              this.createSupply(objData);
            }

            if (res.data.status == 2) {
              this.loading = false;
              miniToastr.error("Numero de pallet ingresado ya éxiste", "");
            }
          })
          .catch((error) => {
            console.log(error.response);
          });
      }
      if (this.existing_pallet == true) {
        const palletData = {
          number: this.contentData.pallet_number,
          destination: this.contentData.destination,
          auto_number: this.autoNumber,
          receipt_waybill: this.waybillID,
          client: this.$store.getters.user.ID_CLIENTE,
          tipo: 2,
          contents: [
            {
              quantity: Number(this.contentData.quantity),
              net_kilograms: Number(this.calculateNet),
              origin_kilograms: Number(this.contentData.origin_kilograms),
              gross_kilograms: Number(this.calculateGross),
              origin: this.contentData.origin,
              condition: this.contentData.condition,
              product_type: this.contentData.product_type.id,
              pallet: this.contentData.pallet,
              lot: this.contentData.lot,
              process_id: "",
              overweight_type: "0",
              creation_date: this.waybillDATE,
              variety: this.contentData.variety,
              client_customer: this.client_customer,
              waybill: this.waybillID,
              container: this.contentData.container.id,
              plant: this.contentData.plant,
              specifications: this.contentData.specifications.filter(Boolean),
              classification: this.contentData.classification,
              palletizing: this.contentData.palletizing.join()
            }
          ]
        };
        this.loading = true;
        this.$axios
          .post("/api/v1/content/create_process_content/", palletData)
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              this.formModal.status = false;
              this.resetDetailForm();

              this.$emit("refreshContents", this.waybillID);
              miniToastr.success("Operación realizada con éxito", "");
              this.createSupply(objData);
            }

            if (res.data.status == 2) {
              this.loading = false;
              miniToastr.error("Numero de pallet ingresado ya éxiste", "");
            }
          })
          .catch((error) => {
            console.log(error.response);
          });
      }
    },
    updateContent(a) {
      const formData = {
        number: this.contentData.pallet_number,
        destination: this.contentData.destination,
        auto_number: this.autoNumber,
        receipt_waybill: this.waybillID,
        tipo: 0,
        contents: [
          {
            id: a,
            quantity: Number(this.contentData.quantity),
            net_kilograms: Number(this.calculateNet),
            origin_kilograms: Number(this.contentData.origin_kilograms),
            gross_kilograms: Number(this.calculateGross),
            origin: this.contentData.origin,
            condition: this.contentData.condition,
            product_type: this.contentData.product_type.id,
            pallet: this.contentData.pallet,
            lot: this.contentData.lot,
            process_id: "",
            creation_date: this.waybillDATE,
            variety: this.contentData.variety,
            client_customer: this.client_customer,
            waybill: this.waybillID,
            overweight_type: "0",
            container: this.contentData.container.id,
            plant: this.contentData.plant,
            specifications: this.contentData.specifications.filter(Boolean),
            classification: this.contentData.classification,
            palletizing: this.contentData.palletizing.join()
          }
        ]
      };
      this.formModal.status = false;
      this.editing_modal = false;
      this.loading = true;
      this.$axios
        .put("/api/v1/content/update_process_content/", formData)
        .then((res) => {
          this.loading = false;
          this.resetDetailForm();
          this.$emit("refreshContents", this.waybillID);
          miniToastr.success("Operación realizada con éxito", "");
        })
        .catch((error) => console.log(error));
    },
    toggle() {
      this.contentData.net_kilograms = this.calculateExport;
      this.contentData.interplanta = !this.interplanta;
    }
  },
  beforeMount() {
    this.getProducts();
  },
  mounted() {
    this.$axios
      .get("/api/comex/destination_market/?no_page")
      .then((res) => {
        this.destinations = res.data;
      })
      .catch((error) => {
        console.log(error.response);
      });
  }
};
</script>
